<template>
    <div>
        <k-button size="mini" plain round :to="detailUrl">查看订单</k-button>
        <template v-if="aprShow && showJdBtn">
            <k-button v-if="isEdit" size="mini" type="danger" plain round :to="`/appraiser/appraisal?orderId=${orderId}`">修改鉴定</k-button>
            <k-button v-else size="mini" type="danger" plain round :to="detailUrl">立即鉴定</k-button>
        </template>

        <template v-if="!aprShow">
            <k-button v-if="status === CONST.ORDER_STATUS_TOPAY" size="mini" type="primary" @click="toPay" plain round>
                立即支付
            </k-button>
            <k-button v-if="status === CONST.ORDER_STATUS_PAUSE" size="mini" type="primary" plain round :to="detailUrl">立即修正</k-button>
<!--            <k-button v-if="status === CONST.ORDER_STATUS_FINISHED" size="mini" type="primary" plain round :to="detailUrl">立即评价</k-button>-->
        </template>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex"

    export default {
        name: "order-btns",
        props: ["orderId", "status", "place"],
        data() {
            return {}
        },
        computed: {
            ...mapGetters("jianding", ["CONST"]),
            showJdBtn() {
                let {status} = this;
                let {ORDER_STATUS_WAIT, ORDER_STATUS_PAUSE, ORDER_STATUS_FINISHED, ORDER_STATUS_EVALUATE} = this.CONST;
                if(status === ORDER_STATUS_WAIT || status === ORDER_STATUS_FINISHED || status === ORDER_STATUS_EVALUATE){
                    return true
                }
                return false
            },
            isEdit(){
                let {status} = this;
                let {ORDER_STATUS_WAIT, ORDER_STATUS_PAUSE, ORDER_STATUS_FINISHED, ORDER_STATUS_EVALUATE} = this.CONST;
                if(status === ORDER_STATUS_FINISHED || status === ORDER_STATUS_EVALUATE){
                    return true
                }
                return false
            },
            aprShow() {
                return this.place === 'appraiser' ? true : false;
            },

            detailUrl(){
                if(this.place === 'appraiser'){
                    return `/appraiser/order/detail?orderId=${this.orderId}`
                }
                return `/my/order/detail?orderId=${this.orderId}`
            }
        },
        methods: {
            ...mapActions("jianding", ["makeOrder", "goCash"]),
            async toPay() {
                if (!this.orderId) {
                    this.$toast("订单ID有误");
                    return
                }
                await this.makeOrder({orderId: this.orderId}).then(R => {

                }).catch(err => {
                    this.$toast(err.message)
                })

            }
        }
    }
</script>

<style scoped>

</style>